import { useCallback, useEffect, useState } from "react";
import { BehaviorSubject, tap } from "rxjs";

export const useBehaviorSubjectState = <T>(
  behaviorSubject: BehaviorSubject<T>
): [T, (state: T) => void, BehaviorSubject<T>] => {
  const [state, setState] = useState<T>(behaviorSubject.getValue());

  const setBehaviorSubjectState = useCallback(
    (state: T) => {
      behaviorSubject.next(state);
    },
    [behaviorSubject]
  );

  useEffect(() => {
    const subscription = behaviorSubject
      .pipe(tap((state) => setState(state)))
      .subscribe();
    return () => {
      subscription.unsubscribe();
    };
  }, [behaviorSubject]);
  return [state, setBehaviorSubjectState, behaviorSubject];
};
